import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import "../../Assets/CSS/CompleteExitInterview.css";

const CompleteExitInterview = ({ setActiveTab }) => {
  const token = localStorage.getItem("token");

  const [requestId, setRequestId] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
console.log('req: ',requestId)
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };


  /* ---------------------------------
     1️⃣ Fetch My Offboarding Request
  ----------------------------------*/
  const fetchMyRequest = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/my-requests`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data && res.data.length > 0) {
        setRequestId(res.data[0].requestId); // latest request
      } else {
        toast.error("No offboarding request found");
      }
    } catch (err) {
      toast.error("Failed to fetch offboarding request");
    }
  };

  /* ---------------------------------
     2️⃣ Fetch Exit Interview Questions
  ----------------------------------*/


  // Initialize answers
  const fetchQuestions = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/configuration/questions`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const activeQuestions = res.data.filter(q => q.isActive);
    setQuestions(activeQuestions);

    const initialAnswers = {};
    activeQuestions.forEach(q => {
      initialAnswers[q.question] = ""; // ✅ QUESTION TEXT
    });
    setAnswers(initialAnswers);
  };

  // Handle change
  const handleChange = (question, value) => {
    setAnswers(prev => ({
      ...prev,
      [question]: value,
    }));
  };

  useEffect(() => {
    fetchMyRequest();
    fetchQuestions();
  }, []);

  /* ---------------------------------
     Handle Answer Change
  ----------------------------------*/

  const handleSubmit = async () => {
    if (!requestId) {
      toast.error("Request ID missing");
      return;
    }

    // validation
    for (let key in answers) {
      if (!answers[key] || answers[key].trim() === "") {
        toast.error("Please answer all questions");
        return;
      }
    }

    try {
      setLoading(true);

      const payload = {
        requestId: requestId,
        interviewDate: new Date().toISOString().split("T")[0], // ✅ today
        summary: "Exit interview submitted by employee",
        answers: answers,
      };

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/submit-exit-interview`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Exit interview submitted successfully");
      setActiveTab("offboadringEmp");

    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Exit interview submission failed"
      );
    } finally {
      setLoading(false);
    }
  };

  /* ---------------------------------
     UI
  ----------------------------------*/
  return (
    <div className="container exit-container">
      <div className="row">
        <div className="col-lg-8 col-md-10">


          {questions.map((q, index) => (
            <div className="mb-4" key={q.questionId}>
              <label className="question-label">
                {index + 1}. {q.question}
              </label>
              <textarea
                className="form-control exit-textarea"
                rows="3"
                value={answers[q.question]}
                onChange={(e) => handleChange(q.question, e.target.value)}
                placeholder="Write your answer..."
              />
            </div>
          ))}


          <button
            className="btn submit-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit & Continue"}
          </button>

        </div>
      </div>
    </div>
  );
};

export default CompleteExitInterview;
